/**
 * 其他业务 API: 关键词搜索、Listing检查、亚马逊订单
 */

import api from './client';

export const keywordSearchAPI = {
    listImports: (params?: { site?: string; search_date?: string }) =>
        api.get('/keyword-search/', { params }),
    getImport: (id: number) => api.get(`/keyword-search/${id}/`),
    deleteImport: (id: number) => api.delete(`/keyword-search/${id}/`),
    upload: (formData: FormData) => api.post('/keyword-search/upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    getResults: (importId: number) => api.get('/keyword-search/results/', {
        params: { import_id: importId }
    }),
    competitorAnalysis: (params?: { import_ids?: string; my_asin?: string }) =>
        api.get('/keyword-search/competitor_analysis/', { params }),
};

export const listingCheckAPI = {
    listItems: () => api.get<any[]>('/listing-checks/'),
    createItem: (data: any) => api.post<any>('/listing-checks/', data),
    initResults: (skuId: number, site: string) =>
        api.get<any[]>('/listing-results/init_results/', { params: { sku_id: skuId, site } }),
    bulkSave: (data: { sku_id: number; site: string; results: any[] }) =>
        api.post('/listing-results/bulk_save/', data),
};

export const amazonOrderAPI = {
    list: (params?: any) => api.get<any>('/orders/', { params }),
    get: (id: string) => api.get<any>(`/orders/${id}/`),
};
